// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__32M1K","content":"RecentSearches_content__Ws_qM"};